import { Link } from "@tanstack/react-router";
import { Mail, Phone, MapPin } from "lucide-react";
import { initiatives, daanAmrutLogo } from "@/project/data/sample";

export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-border/60 bg-[var(--maroon-deep)] text-[var(--cream)]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="inline-flex items-center gap-3 rounded-xl bg-white/95 px-3 py-2">
            <img src={daanAmrutLogo} alt="Daan Amrut Foundation" className="h-10 w-auto" />
          </div>
          <p className="mt-4 font-display text-lg font-semibold text-[var(--saffron)]">Daan Amrut Foundation</p>
          <p className="mt-2 text-sm text-[var(--cream)]/75">
            A public charitable trust running seven initiatives across animal welfare, education,
            healthcare, food, women's empowerment, environment and disaster relief — powered by
            transparent, technology-first philanthropy.
          </p>
        </div>

        <div>
          <h4 className="font-display text-base font-semibold text-[var(--saffron)]">Initiatives</h4>
          <ul className="mt-4 space-y-2 text-sm text-[var(--cream)]/80">
            {initiatives.slice(0, 6).map((i) => (
              <li key={i.slug}>
                <Link to="/initiatives/$slug" params={{ slug: i.slug }}>{i.name}</Link>
              </li>
            ))}
            <li><Link to="/initiatives">See all initiatives →</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-base font-semibold text-[var(--saffron)]">Foundation</h4>
          <ul className="mt-4 space-y-2 text-sm text-[var(--cream)]/80">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/leadership">Leadership & Trustees</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><Link to="/media">Media</Link></li>
            <li><Link to="/volunteer">Volunteer</Link></li>
            <li><Link to="/register-institution">Partner with us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-base font-semibold text-[var(--saffron)]">Reach Us</h4>
          <ul className="mt-4 space-y-2 text-sm text-[var(--cream)]/80">
            <li className="flex gap-2"><Mail className="h-4 w-4 shrink-0" /> info@daanamrut.example</li>
            <li className="flex gap-2"><Phone className="h-4 w-4 shrink-0" /> +91 79 4890 1200</li>
            <li className="flex gap-2"><MapPin className="h-4 w-4 shrink-0" /> Ahmedabad, Gujarat, India</li>
          </ul>
          <Link to="/donate" className="mt-5 inline-block rounded-full bg-[var(--saffron)] px-5 py-2 text-sm font-semibold text-[var(--maroon-deep)] hover:bg-[var(--saffron-deep)] hover:text-white transition">
            Donate to any initiative →
          </Link>
        </div>
      </div>
      <div className="border-t border-[var(--cream)]/15">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-[var(--cream)]/60 sm:flex-row sm:px-6">
          <p>© {new Date().getFullYear()} Daan Amrut Foundation. Registered public charitable trust. 80G & 12A certified.</p>
          <div className="flex gap-5">
            <Link to="/about">Privacy</Link>
            <Link to="/about">Terms</Link>
            <Link to="/contact">Refund & Compliance</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}